<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">Edit Vendor</oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="3" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="vendor.name"
                :label="$t('general.name')"
                :rules="rules.name"
                required
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model.trim="vendor.contactNumber"
                :label="$t('general.mobile')"
                :rules="rules.contactNumber"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="vendor.email"
                :label="$t('general.email')"
                :rules="rules.email"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field v-model="vendor.website" label="Website" />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="vendor.address"
                label="Address"
                type="textarea"
                :rules="rules.address"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import {
  required,
  shouldNotExceedCharLength,
  validPhoneNumberFormat,
  validEmailFormat,
} from '@ohrm/core/util/validation/rules';

export default {
  props: {
    vendorId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/asset_vendors',
    );
    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      vendor: {
        id: '',
        name: '',
        contactNumber: '',
        email: '',
        website: '',
        address: '',
      },
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
        contactNumber: [shouldNotExceedCharLength(25), validPhoneNumberFormat],
        email: [shouldNotExceedCharLength(50), validEmailFormat],
        website: [shouldNotExceedCharLength(100)],
        address: [shouldNotExceedCharLength(200)],
      },
    };
  },

  created() {
    this.isLoading = true;
    this.http
      .get(this.vendorId)
      .then((response) => {
        const {data} = response.data;
        this.vendor.id = data.id;
        this.vendor.name = data.name;
        this.vendor.contactNumber = data.contactNumber;
        this.vendor.email = data.email;
        this.vendor.website = data.website;
        this.vendor.address = data.address;
        // Fetch list data for unique test
        return this.http.getAll({limit: 0});
      })
      .then((response) => {
        const {data} = response.data;
        this.rules.name.push((v) => {
          const index = data.findIndex(
            (item) =>
              String(item.name).toLowerCase() == String(v).toLowerCase(),
          );
          if (index > -1) {
            const {id} = data[index];
            return id !== this.vendor.id
              ? this.$t('general.already_exists')
              : true;
          } else {
            return true;
          }
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.vendorId, {
          name: this.vendor.name,
          contactNumber: this.vendor.contactNumber,
          email: this.vendor.email,
          website: this.vendor.website,
          address: this.vendor.address,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        });
    },
    onCancel() {
      navigate('/admin/viewAssetVendor');
    },
  },
};
</script>
